var map = {
	"./IMG_8055.JPG": 807,
	"./IMG_8061.JPG": 20,
	"./IMG_8078.JPG": 538,
	"./IMG_8081.JPG": 78,
	"./IMG_8157.JPG": 288,
	"./IMG_8159.JPG": 508,
	"./IMG_8162.JPG": 507,
	"./IMG_8185.JPG": 809,
	"./IMG_8186.JPG": 946,
	"./IMG_8191.JPG": 222,
	"./IMG_8214.JPG": 325,
	"./IMG_8216.JPG": 16,
	"./IMG_8226.JPG": 237,
	"./IMG_8239.JPG": 191,
	"./IMG_8242.JPG": 126,
	"./IMG_8258.JPG": 820,
	"./IMG_8263 2.JPG": 878,
	"./IMG_8266.JPG": 422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;